import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, CanActivate } from '@angular/router';
import { AuthGuardAll, AuthGuardEntrega, AuthGuardCheckIn } from './services/auth.guard';

const routes: Routes = [
  // NO-AUTH
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)},
  { path: 'register', loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)},
  // AUTH
  { path: '', canActivate: [AuthGuardAll], children: [
    {
      path: 'home',
      loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
    },
    {
      path: 'profile',
      loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
    },
    {
      path: 'holerite',
      loadChildren: () => import('./pages/holerite/holerite.module').then( m => m.HoleritePageModule)
    },
    {
      canActivate: [AuthGuardEntrega],
      path: 'entrega',
     loadChildren: () => import('./pages/entrega/entrega.module').then( m => m.EntregaPageModule)
    },
    {
      canActivate: [AuthGuardCheckIn],
      path: 'checkin',
      loadChildren: () => import('./pages/checkin/checkin.module').then( m => m.CheckinPageModule)
    }
  ]},
  {
    path: 'check-in-modal',
    loadChildren: () => import('./modals/check-in-modal/check-in-modal.module').then( m => m.CheckInModalPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
